var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.3125 116.438V90.5625H90.5625L69 64.6875L47.4375 90.5625H64.6875V116.438H43.125V116.222C42.3973 116.262 41.71 116.438 40.9688 116.438C32.3907 116.438 24.1639 113.03 18.0983 106.964C12.0326 100.899 8.625 92.6718 8.625 84.0938C8.63618 76.1753 11.5639 68.5384 16.849 62.6418C22.1341 56.7451 29.4061 53.002 37.2762 52.1273C38.6913 44.7477 42.6317 38.0911 48.4207 33.3006C54.2096 28.51 61.4859 25.8846 69 25.875C76.5164 25.8814 83.7959 28.5055 89.5876 33.2963C95.3793 38.0871 99.3217 44.7455 100.737 52.1273C108.602 53.0082 115.868 56.754 121.148 62.65C126.427 68.546 129.351 76.1794 129.362 84.0938C129.362 92.6718 125.954 100.899 119.888 106.964C113.823 113.03 105.596 116.438 97.0178 116.438C96.3035 116.438 95.6027 116.262 94.8615 116.222V116.438H73.3125Z",
    fill: "#373535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.cd3324abdc55e0c54752f866b0af4ab6.svg";
export { ForwardRef as ReactComponent };